import { createAction } from 'redux-act';

export const getAllTagsSaga: any = createAction('getAllTagsSaga');
export const setAllTags: any = createAction('setAllTags', (tags: any) => ({ tags }));